import { gql } from '@apollo/client';

export const LOGIN_MUTATION = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      success
      message
      user {
        id
        username
        email
        firstName
        lastName
        isStaff
        isSuperuser
        companyName
        role
      }
    }
  }
`;

export const LOGOUT_MUTATION = gql`
  mutation Logout {
    logout {
      success
      message
    }
  }
`;

export const CURRENT_USER_QUERY = gql`
  query CurrentUser {
    currentUser {
      id
      username
      email
      firstName
      lastName
      isStaff
      isSuperuser
      companyName
      role
    }
  }
`;

// Get current user with full company and role context
export const GET_ME_QUERY = gql`
  query GetMe {
    me {
      id
      username
      email
      role
      isViewer
      isEditor
      isAdmin
      company {
        id
        name
        plan
      }
    }
  }
`;

export interface User {
  id: number;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  isStaff: boolean;
  isSuperuser: boolean;
  companyName?: string;
  role?: string;
}

export interface LoginInput {
  username: string;
  password: string;
}

export interface LoginResponse {
  login: {
    success: boolean;
    message: string;
    user?: User;
  };
}

export interface LogoutResponse {
  logout: {
    success: boolean;
    message: string;
  };
}

export interface CurrentUserResponse {
  currentUser?: User;
}
